// pkg72 — LawMighty retheme: brand hex sweep (#1a1a1a→#0F1838 NAVY_DEEP, #0f0f0f→#0A1028, #f8f8f8→#F5F1E8 CREAM, #c0392b→#B85042 TERRA) — delivered 2026-07-12
// pkg67 — success state shows the firm's portal address prominently with a bookmark nudge (the one thing a new owner must not lose); notes it was also emailed (D-67j) — delivered 2026-07-12
import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { publicApi } from '../utils/api';

// Email-verification landing (pkg15v2). Reads ?token=, confirms it, and on
// success activates the firm and points the owner at their subdomain login.
const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'lawmighty.com';

export default function VerifyPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState('verifying'); // verifying | ok | error
  const [subdomain, setSubdomain] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setMessage('This link is missing its verification token.'); return; }
    publicApi.verifyFirm(token)
      .then((r) => { setSubdomain(r.subdomain); setState('ok'); })
      .catch((err) => { setState('error'); setMessage(err.message || 'This link is invalid or has expired.'); });
  }, [token]);

  const portalHost = `${subdomain}.${ROOT_DOMAIN}`;

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-brand"><h1>Email verification</h1></div>
        {state === 'verifying' && (
          <p style={{ textAlign: 'center', color: '#888' }}><span className="spinner" /> Verifying…</p>
        )}
        {state === 'ok' && (
          <>
            <div className="alert alert-success">Your firm is active. Welcome to LawMighty.</div>
            {/* pkg67 — the portal address is the centerpiece: highlighted,
                with a bookmark nudge, and echoed in the welcome email. */}
            <div style={{
              background: '#F5F1E8', border: '1px solid #ddd', borderRadius: 6,
              padding: '14px 16px', textAlign: 'center', marginBottom: 16,
            }}>
              <div style={{
                fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#888',
                textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4,
              }}>
                Your firm's address
              </div>
              <div style={{ fontSize: 17, fontWeight: 600, color: '#1a5276', wordBreak: 'break-all' }}>
                {portalHost}
              </div>
              <p style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', color: '#555', margin: '8px 0 0', lineHeight: 1.5 }}>
                Bookmark it — this is where you and your clients sign in.
                We've also emailed it to you.
              </p>
            </div>
            <a className="btn btn-primary btn-block" href={`https://${portalHost}/admin`}>
              Sign in to {portalHost}
            </a>
          </>
        )}
        {state === 'error' && (
          <>
            <div className="alert alert-error">{message}</div>
            <p style={{ fontSize: 13, color: '#888' }}><Link to="/signup">Start over</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
